import React, { useRef } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import {
  Box,
  Stack,
  MenuItem,
  Autocomplete,
  Modal,
  Fab,
  Tooltip,
  Typography,
  Switch,
  IconButton,
} from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";
import PrintIcon from "@mui/icons-material/Print";
import TextField from "@mui/material/TextField";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import Button from "@mui/material/Button";
import BillSearch from "@mui/icons-material/Search";
import { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { createFilterOptions } from "@mui/material/Autocomplete";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";
import { Redirect, Link } from "react-router-dom";
import { purple } from "@mui/material/colors";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Draggable from "react-draggable";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import AddBoxIcon from "@mui/icons-material/AddBox";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import TaskIcon from "@mui/icons-material/Task";
import CancelIcon from "@mui/icons-material/Cancel";
import ImportExcel from "../StockTransfer/Stkimportexcel";
toast.configure();

//STYLED BUTTON
const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: purple[500],
  boxShadow: "2px 2px 6px  #404142",
  "&:hover": {
    backgroundColor: purple[700],
  },
}));

const TransferShortExcess = () => {
  const OPTIONS_LIMIT2 = 15;
  const filterOptions = createFilterOptions({
    limit: OPTIONS_LIMIT2,
    trim: true,
  });
  const [disableSave, setDisableSave] = useState(false);
  //GET THE TOKEN FROM HELPER CLASS

  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/sparepartsLogin" />;
    }
  };
  const [searchdisabled, setSearchDisabled] = useState(true);
  const [searchbtndisabled, setSearchbtndisabled] = useState(true);
  const [searchInput, setSearchInput] = useState(null);
  const [searchInputOpts, setSearchInputOpts] = useState([]);
  const date = new Date();
  const [orderdate, setorderdate] = useState(date);
  const [mode, setMode] = useState(1);
  const [transferNo, settransferNo] = useState(null);
  const [transferNoOpts, settransferNoOpts] = useState([]);
  const [dataarray, setdataarray] = useState([]);
  const [disableupdate, setdisableupdate] = useState(false);
  const columns = [
    {
      field: "srl",
      headerClassName: "super-app-theme--header",
      headerName: "Srl",
      type: "number",
      width: 80,
    },
    {
      field: "itemcode",
      headerClassName: "super-app-theme--header",
      headerName: "Item Code",
      type: "number",
      //   align: "left",
      width: 350,
    },
    {
      field: "itemname",
      headerClassName: "super-app-theme--header",
      headerName: "Item Name",
      type: "number",
      //   align: "left",
      width: 350,
    },

    {
      field: "qty",
      headerClassName: "super-app-theme--header",
      headerName: "Transfer Qty",
      type: "number",
      width: 150,
    },
    {
      field: "recvqty",
      headerClassName: "super-app-theme--header",
      headerName: "Recieve Qty",
      type: "number",
      width: 150,
      editable: true,
      valueSetter: (params) => {
        console.log(params.row);
        const newValue = parseFloat(params.value);
        const transferQty = parseFloat(params.row.qty);

        // Check if the new value is 0 or less
        if (newValue <= 0) {
          toast.error("Receive quantity must be greater than 0!", {
            toastId: "error_zero",
          });
          return params.row;
        }

        // Check if the received quantity is the same as transfer quantity
        if (transferQty === newValue) {
          toast.error("Can't Be Same As Transfer Qty!", {
            toastId: "error1",
          });
          return params.row;
        } else {
          const recvqty = params.value;
          const qty = params.row.qty;
          const balqty = parseFloat(recvqty) - parseFloat(qty);

          const upd_obj = dataarray.findIndex(
            (obj) => parseInt(obj.itemid) === parseInt(params.row.itemid)
          );

          dataarray[upd_obj].recvqty = recvqty;
          dataarray[upd_obj].qty = qty;
          dataarray[upd_obj].balqty = balqty;
          return { ...params.row, recvqty, balqty };
        }
      },
    },

    {
      field: "balqty",
      headerClassName: "super-app-theme--header",
      headerName: "Balance Qty",
      type: "number",
      width: 150,
    },
    // {
    //   field: "value",
    //   headerClassName: "super-app-theme--header",
    //   headerName: "value",
    //   type: "number",
    //   width: 100,
    // },
    // {
    //   field: "cgstamt",
    //   headerClassName: "super-app-theme--header",
    //   headerName: "cgstamt",
    //   type: "number",
    //   width: 100,
    // },
    // {
    //   field: "sgstamt",
    //   headerClassName: "super-app-theme--header",
    //   headerName: "sgstamt",
    //   type: "number",
    //   width: 100,
    // },
    // {
    //   field: "igstamt",
    //   headerClassName: "super-app-theme--header",
    //   headerName: "igstamt",
    //   type: "number",
    //   width: 100,
    // },
    // {
    //   field: "netamt",
    //   headerClassName: "super-app-theme--header",
    //   headerName: "netamt",
    //   type: "number",
    //   width: 100,
    // },
  ];
  const allmodes = [
    {
      value: 1,
      label: "New",
    },
    {
      value: 2,
      label: "Edit",
    },
  ];
  const handleSearch = async (e) => {
    e.preventDefault();
    // try {
    //   const response = await fetch(`/stktransfer/doc/${searchInput.docid}`, {
    //     method: "GET",
    //     headers: {
    //       sptoken: userToken,
    //     },
    //   });
    //   const jsonData = await response.json();
    //   setemodearray(jsonData.detail);
    //   setorderdate(jsonData.header.docdate);
    //   setbranchinput({
    //     branchid: jsonData.header.tobranchid,
    //     branchname: jsonData.header.branchname,
    //   });
    //   setprintbtndisable(true);
    // } catch (err) {
    //   console.log(err.message);
    // }
  };

  //docnos from stk transfer header
  async function gettransferdocnos() {
    try {
      const response = await fetch("/stktransfer/shortexcess/documents", {
        method: "GET",
        headers: {
          sptoken: userToken,
        },
      });
      const data = await response.json();
      //console.log(data);
      settransferNoOpts(data);
    } catch (error) {
      console.log(error.message);
    }
  }
  useEffect(() => {
    gettransferdocnos();
  }, []);

  // transfer doc details
  const handleTransDocSearch = async (e) => {
    e.preventDefault();
    try {
      const body = { id: transferNo.docid };
      const response = await fetch("/stktransfer/shortexcess/docdata", {
        method: "POST",
        headers: { "Content-Type": "application/json", sptoken: userToken },
        body: JSON.stringify(body),
      });
      const jsonData = await response.json();
      console.log(jsonData);
      setdataarray(jsonData);
    } catch (err) {
      console.log(err.message);
    }
  };

  //savee
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (transferNo === null) {
      toast.error("Please Select A Docno!!");
      setDisableSave(false);
      return;
    }
    setDisableSave(true);
    try {
      const body = {
        documentdate: orderdate,
        dataarray,
        stktransferid: transferNo.docid,
      };
      const response = await fetch("/stktransfer/shortexcess/in", {
        method: "POST",
        headers: { "Content-Type": "application/json", sptoken: userToken },
        body: JSON.stringify(body),
      });

      const parseRes = await response.json();
      if (parseRes.type === "success") {
        toast.success(parseRes.message, {
          autoClose: false,
          onClose: () => window.location.reload(false),
        });
      } else {
        setDisableSave(false);
        toast.error(parseRes.message);
      }
    } catch (err) {
      setDisableSave(false);
      console.log(err.message);
    }
  };
  //update
  const handleupdate = async (e) => {
    e.preventDefault();
    // if (transferNo === null) {
    //   toast.error("Please Select A Docno!!");
    //   setDisableSave(false);
    //   return;
    // }
    // setDisableSave(true);
    // try {
    //   const body = {
    //     documentdate: orderdate,
    //     dataarray,
    //     stktransferid: transferNo.docid,
    //   };
    //   const response = await fetch("/stktransfer/shortexcess/in", {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json", sptoken: userToken },
    //     body: JSON.stringify(body),
    //   });

    //   const parseRes = await response.json();
    //   if (parseRes.type === "success") {
    //     toast.success(parseRes.message, {
    //       autoClose: false,
    //       onClose: () => window.location.reload(false),
    //     });
    //   } else {
    //     setDisableSave(false);
    //     toast.error(parseRes.message);
    //   }
    // } catch (err) {
    //   console.log(err.message);
    // }
  };
  return (
    <div>
      <Sidebar
        Title={"TRANSFER SHORT/EXCESS"}
        expandedPanel={"panel2"}
        children={
          <Box
            component="form"
            sx={{
              width: "100%",
            }}
            autoComplete="off"
          >
            <Stack
              spacing={1}
              mb={"15px"}
              direction="row"
              justifyContent={"center"}
            >
              <Autocomplete
                disabled={searchdisabled}
                id="partyno"
                value={searchInput}
                filterOptions={filterOptions}
                onChange={(event, newValue) => {
                  setSearchInput(newValue);
                }}
                options={searchInputOpts}
                getOptionLabel={(option) => option.docno}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "500px",
                    }}
                    {...params}
                    size="small"
                    placeholder="Search Doc No."
                  />
                )}
              />
              <ColorButton
                disabled={searchbtndisabled}
                //type="search"
                variant="contained"
                key="one"
                onClick={handleSearch}
                sx={{
                  borderTopRightRadius: "50px",
                  borderBottomRightRadius: "50px",
                }}
              >
                <SearchRoundedIcon />
                SEARCH
              </ColorButton>
            </Stack>
            <hr />
            <Stack
              spacing={1}
              columnGap={2}
              mb={2}
              direction="row"
              mt={2}
              ml={4}
            >
              <TextField
                id="editmode"
                required
                select
                label="Edit Mode"
                value={mode}
                onChange={(e) => {
                  setMode(e.target.value);
                  if (e.target.value === 2) {
                    setSearchDisabled(false);
                    setSearchbtndisabled(false);
                  } else {
                    setSearchDisabled(true);
                    setSearchbtndisabled(true);
                  }
                }}
                // helperText="Select customer Edit mode"
                variant="outlined"
                sx={{
                  width: "20%",
                }}
                size="small"
              >
                {allmodes.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Date"
                  inputFormat="DD/MM/YYYY"
                  value={orderdate || null}
                  onChange={(newValue) => {
                    setorderdate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      sx={{
                        width: "20%",
                      }}
                      size="small"
                    />
                  )}
                />
              </LocalizationProvider>
              <Autocomplete
                disabled={!searchdisabled}
                id="partyno"
                value={transferNo}
                filterOptions={filterOptions}
                onChange={(event, newValue) => {
                  settransferNo(newValue);
                }}
                options={transferNoOpts}
                getOptionLabel={(option) => option.docno}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "500px",
                    }}
                    {...params}
                    size="small"
                    placeholder="Transfer Doc No."
                  />
                )}
              />
              <ColorButton
                disabled={!searchbtndisabled}
                //type="search"
                variant="contained"
                key="one"
                onClick={handleTransDocSearch}
                sx={{
                  borderTopRightRadius: "50px",
                  borderBottomRightRadius: "50px",
                }}
              >
                <SearchRoundedIcon />
                SEARCH
              </ColorButton>
            </Stack>
            <Stack columnGap={3} direction="row" mt={1}>
              <Box
                sx={{
                  height: 550,
                  width: "100%",
                  mt: "15px",
                  boxShadow: "2px 6px 15px #5a5a5a",
                  // border: "0.5px solid black",
                  // borderRadius: "5px",
                  "& .super-app-theme--header": {
                    backgroundColor: "#3bb9ff",
                    color: "#000",
                  },
                }}
              >
                <DataGrid
                  sx={{ border: "1px solid #000" }}
                  rowHeight={25}
                  headerHeight={40}
                  initialState={{
                    sorting: {
                      sortModel: [{ field: "serial", sort: "desc" }],
                    },
                  }}
                  showColumnRightBorder={true}
                  rows={dataarray}
                  columns={columns}
                  pageSize={100}
                  getRowId={(row) => row.itemid}
                />
              </Box>
            </Stack>
            <Stack
              columnGap={3}
              direction="row"
              mt={5}
              justifyContent={"center"}
            >
              {parseInt(mode) === 1 ? (
                <>
                  {" "}
                  <Button
                    //type="submit"
                    onClick={handleSubmit}
                    disabled={disableSave}
                    variant="contained"
                    color="success"
                    size="large"
                    sx={{ boxShadow: "2px 2px 6px  #404142" }}
                  >
                    SAVE ORDER
                  </Button>
                </>
              ) : (
                <>
                  {" "}
                  <Button
                    //type="submit"
                    disabled={disableupdate}
                    onClick={handleupdate}
                    variant="contained"
                    color="primary"
                    size="large"
                    sx={{ boxShadow: "2px 2px 6px  #404142" }}
                  >
                    UPDATE ORDER
                  </Button>
                </>
              )}
            </Stack>
          </Box>
        }
      />
      {redirectToLoginPage()}
    </div>
  );
};

export default TransferShortExcess;
